export enum GNWPElasticEvents {
    OpenClientAuthenticated = 'open-client-authenticated',
    OpenClientUnauthorized = 'open-client-unauthorized',
    OpenServiceAuthenticated = 'open-service-authenticated',
}
